import * as React from 'react';
import { getPublicRuntimeConfig } from '@helpers/getPublicRuntimeConfig';

const APP_TLD = getPublicRuntimeConfig('APP_TLD');
const ASSETS_URL = getPublicRuntimeConfig('ASSETS_URL');

export const Slogan: React.FC<{ className?: string }> = ({ className }) => {
  const src = `${ASSETS_URL}/static/images/slogan-${APP_TLD}.`;
  return (
    <picture>
      <source srcSet={`${src}webp`} type="image/webp" />
      <img src={`${src}png`} className={className} alt="slogan" data-testid="slogan-image" loading="lazy" />
    </picture>
  );
};
